<template>
  <div>
    <SmartTitle class="mb-4" heading="1" weight="medium"
      >Relatório de Acessos</SmartTitle
    >
    <AccessReportFilter
      @skeleton-handler="skeletonHandler"
      @save-filter="saveFilter"
    />
    <div
      class="header__wrapper flex align-center justify-between mt-3"
      style="float: right"
    >
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <SmartButton
          v-on="on"
          class="export-button mt-1"
          @click="sendInfoToExport"
          :loading="loadingAccess"
        >
          Exportar Arquivo
        </SmartButton>
      </template>
      <span>Exportação limitada a 10.000 registros.</span>
    </v-tooltip>
    </div>
    <div v-if="!loading" class="align-start" style="margin-top: 80px">
      <VDataTable
        :headers="headers"
        :items="listItems"
        item-key=""
        hide-actions
        class="elevation-1 mt-1"
        :class="{ loading: false }"
        no-data-text="Não há dados a serem exibidos"
      >
        <template v-slot:items="{ item }">
          <td class="limited-info-style limited-width">
            <span>{{ item.registration || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.name || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.role || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.km || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.visitas || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.metas || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.monitoria || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.pesquisa || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.venda_cantada || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.termo || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.sigtim || "-" }}</span>
          </td>
          <td class="limited-info-style limited-width">
            <span>{{ item.ultimo_acesso_geral || "-" }}</span>
          </td>
        </template>
      </VDataTable>
    </div>
    <SmartCard class="p-3" style="margin-top: 80px" v-else>
      <SmartSkeletonLoading :items="11" :height="4" />
    </SmartCard>

    <div v-if="lengthActive > 0" class="text-center mb-5 gu-access-report-pagination">
      <VPagination
        v-model="currentPageActive"
        :length="lengthActive"
        @input="changePage(currentPageActive)"
        :value="currentPageActive"
        :total-visible="0"
        :disabled="loading"
        circle
        class="mt-4"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import { getBlobError, downloadCsvFile } from "utils/blob";
import { formatBRDateTimeSecs } from "utils/date";

export default {
  name: "AccessReport",
  components: {
    AccessReportFilter: () => import("./components/AccessReportFilter.vue"),
  },
  mixins: [clickaway],
  data() {
    return {
      totalPerPage: 10,
      currentPageActive: 1,
      highestPage: 1,
      maxPage: Math.pow(10, 10),
      resultFilter: {},
      type: "",
      loading: false,
      loadingAccess: false,
      list: [],
      currentFilter: {},
      exportValue: false,
      headers: [
        { text: "Matrícula", value: "", sortable: false },
        { text: "Nome", value: "", sortable: false },
        { text: "Perfil", value: "", sortable: false },
        { text: "KM", value: "", sortable: false },
        { text: "Visitas", value: "", sortable: false },
        { text: "Metas", value: "", sortable: false },
        { text: "Monitoria", value: "", sortable: false },
        { text: "Pesquisa", value: "", sortable: false },
        { text: "Venda Cantada", value: "", sortable: false },
        { text: "Termo", value: "", sortable: false },
        { text: "SigTIM", value: "", sortable: false },
        { text: "Acesso Geral", value: "", sortable: false },
      ],
    };
  },
  watch: {
    AccessReportList(list) {
      this.list = list;
    },
    currentPageActive(newValue) {
      if (newValue > this.highestPage) {
        this.highestPage = newValue;
      }
    }
  },
  computed: {
    ...mapGetters({
      AccessReportList: "guReports/AccessReportList",
    }),
    listItems() {
      return this.list;
    },
    lengthActive() {
      if (this.highestPage < this.currentPageActive) {
        return this.currentPageActive + 1;
      }

      if (this.highestPage > this.maxPage) {
        if (this.highestPage > this.maxPage + 1) {
          this.maxPage = this.highestPage - 1;
        }
        return this.maxPage + 1;
      }

      if (typeof this.AccessReportList === 'undefined') {
        this.maxPage = this.currentPageActive;
        return this.currentPageActive;
      }

      if (typeof this.AccessReportList.data !== 'undefined' && this.AccessReportList.data.length < this.totalPerPage) {
        this.maxPage = this.currentPageActive;
        return this.currentPageActive;
      }

      this.maxPage = this.highestPage + 1;

      return this.maxPage;
    }
  },
  methods: {
    ...mapActions({
      fetchAccessReportList: "guReports/fetchAccessReportList",
      fetchExportAccess: "guReports/fetchExportAccess",
      fetchUsers: "guReports/fetchUsers",
    }),
    saveFilter(filter) {
      this.currentFilter = { ...filter };
      this.maxPage = 1;
      this.highestPage = 1;
      this.currentPageActive = 1;
      this.changePage(1);
    },
    skeletonHandler(state) {
      this.loading = state;
    },
    sendInfoToExport() {
      this.resultFilter = {
        initial_date: this.currentFilter.date_start,
        final_date: this.currentFilter.date_end,
        registration: this.currentFilter.registration,
      };

      this.loadingAccess = true;
      this.fetchExportAccess(this.resultFilter)
        .then((data) => {
          downloadCsvFile({
            filename: "relatório-de-acessos",
            file: data.data,
          });
        })
        .catch((err) => {
          getBlobError(err);
        })
        .finally(() => {
          this.loadingAccess = false;
        });
    },
    async changePage(page, fechUsers) {
      fechUsers = !!fechUsers;

      let DTO = {
        page: page,
        ...this.currentFilter
      };

      this.loading = true;

      await this.fetchAccessReportList({ DTO });

      if (typeof this.AccessReportList !== 'undefined' && this.AccessReportList.data.length > 0) {
        this.list = this.AccessReportList.data.map((item) => ({
          registration: item.registration,
          name: item.name,
          profile: item.profile,
          role: item.role,
          km: item ? formatBRDateTimeSecs(item.km) : "-",
          visitas: item ? formatBRDateTimeSecs(item.visitas) : "-",
          metas: item ? formatBRDateTimeSecs(item.metas) : "-",
          monitoria: item ? formatBRDateTimeSecs(item.monitoria) : "-",
          pesquisa: item ? formatBRDateTimeSecs(item.pesquisa) : "-",
          venda_cantada: item ? formatBRDateTimeSecs(item.venda_cantada) : "-",
          termo: item ? formatBRDateTimeSecs(item.termo) : "-",
          sigtim: item ? formatBRDateTimeSecs(item.sigtim) : "-",
          ultimo_acesso_geral: item ? formatBRDateTimeSecs(item.ultimo_acesso_geral) : "-",
        }));
      }

      if (fechUsers) {
        const filterOptions = {
          registration: "",
        };

        Promise.all([this.fetchUsers({ filterOptions })]);
      }

      this.loading = false;
    },
  },
  mounted() {
    this.changePage(1, true);
  },
};
</script>

<style lang="scss">
.header__wrapper {
  z-index: 100;
}
.checkbox-all__wrapper--helper {
  max-width: 355px;
}
.export-button {
  min-width: 199px;
}
.checkbox__wrapper {
  max-width: 35px;
}
</style>
